import { authConstants } from "../../_constants";

let user = JSON.parse(localStorage.getItem("jigsawUser"));
const initialState = user
  ? { loggedIn: true, user, error: "" }
  : { loggedIn: false, user: {}, error: "" };

//login reducer
export const signin_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.LOGIN_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.LOGIN_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        user: action.payload,
      };
    case authConstants.LOGIN_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//signup reducer
export const signup_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.SIGNUP_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.SIGNUP_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        user: action.payload,
      };
    case authConstants.SIGNUP_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//reset password reducer
export const reset_password_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.RESET_PASSWORD_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.RESET_PASSWORD_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case authConstants.RESET_PASSWORD_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//reset password confirm reducer
export const reset_password_confirm_user_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//logout reducer
export const logout_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.LOGOUT_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.LOGOUT_USER_ACTION_SUCCESS:
      return {
        loggedIn: false,
        user: {},
      };
    case authConstants.LOGOUT_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//select role
export const select_role_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.SELECT_ROLE_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.SELECT_ROLE_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case authConstants.SELECT_ROLE_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//google login
export const google_login_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.GOOGLE_LOGIN_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.GOOGLE_LOGIN_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        user: action.payload,
      };
    case authConstants.GOOGLE_LOGIN_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//google login
export const user_meta_data_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.USER_META_DATA_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.USER_META_DATA_SUCCESS:
      return {
        loggedIn: true,
        userMetaData: action.payload,
      };
    case authConstants.USER_META_DATA_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//google login
export const get_loggedin_user_meta_data_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.GET_LOGGEDIN_USER_META_DATA_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.GET_LOGGEDIN_USER_META_DATA_SUCCESS:
      return {
        loggedIn: true,
        loggedInMetaData: action.payload,
      };
    case authConstants.GET_LOGGEDIN_USER_META_DATA_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


//user timzone
export const update_user_timezone_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.UPDATE_USER_TIMEZONE_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case authConstants.UPDATE_USER_TIMEZONE_SUCCESS:
      return {
        loggedIn: true,
        userTimezone: action.payload,
      };
    case authConstants.UPDATE_USER_TIMEZONE_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};